import bok1Img from 'assets/img/bok1.png';
import bsdImg from 'assets/img/bsd.png';
import badImg from 'assets/img/bad.png';
import bok2Img from 'assets/img/bok2.png';
import scalesImg from '../../../shared/assets/img/scales.png';

export interface DeviceCardData {
  vendorName: string;
  name: string;
  description: string;
  img: string;
  registryName: string;
}

export const CARDS: DeviceCardData[] = [
  {
    vendorName: '“Цифровая трансформация пчеловодства”',
    name: 'Программно аппаратный-комплекс "Цифровой улей"',
    description: `
"Цифровой улей"— это идеальный выбор для начинающих и профессиональных пчеловодов или тех, кто хочет познакомиться с цифровыми технологиями и улучшить управление своей пасекой. БАД агрегирует на себе несколько БСД, и передает данные на единую цифровую платформу пчеловодства.`,
    img: bsdImg,
    registryName: 'БСД',
  },
  {
    vendorName: '“Точный контроль массы улья”',
    name: 'Весы на один улей',
    description: `
«Цифровые весы для улья» - это современное решение для точного контроля массы улья и эффективного управления пасекой.`,
    img: scalesImg,
    registryName: 'ВДТ (Весы)',
  },
  {
    vendorName: '“Контроль доступа без лишних модулей”',
    name: 'Блок открытия крышки без Глонасс и GSM',
    description: `
Контроль доступа к улью без Глонас и GSM`,
    img: bok1Img,
    registryName: 'БОК',
  },
  {
    vendorName: '“Центр управления всей пасекой”',
    name: 'Центр управления пасекой',
    description: `
Одноплатный компьютер «Центр управления пасекой» - это ключевое устройство для сбора и обработки данных с ПАК «Цифровой улей» и Цифровых весов.
Собирает данные со всех подключенных устройств (температура, влажность, активность пчел и т.д.). Автоматически отправляет данные в цифровой Журнал пчеловода для анализа и контроля.
Поддерживает до 30 ПАК "Цифровой улей", что позволяет охватить как небольшие пасеки, так и крупные хозяйства.`,
    img: badImg,
    registryName: 'БАД',
  },
  {
    vendorName: '“Безопасность и контроль местоположения”',
    name: 'Контроль доступа к улью (с Глонас и GSM)',
    description: `
«Контроль доступа к улью» -  блок открытия крышки улья, совмещенный с модулем определение местоположения во всемирной системе координат, это надежный инструмент для защиты вашей пасеки от несанкционированного доступа и оперативного реагирования на инциденты.`,
    img: bok2Img,
    registryName: 'БГНСС',
  },
];
